import { Component, OnInit, Injectable, Inject, ViewChild, AfterViewInit } from "@angular/core";
import { AlertService, MessageSeverity, MessageType } from "../services/alert.service";
import { AuthService } from "../services/auth.service";
import { HttpClient } from "@angular/common/http";
import { Route, Router, ActivatedRoute } from "@angular/router";
import { Core } from "../shared/core";
import { jqxGridComponent }  from "jqwidgets-ng/jqxgrid";
import { DownloadService } from '../services/download.service';
import { jqxWindowComponent }  from 'jqwidgets-ng/jqxwindow';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { LoginResponse } from '../models/account/login-response.model';
import { map } from 'rxjs/operators';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorageService } from '../services/local-storage.service';
import { Const } from '../services/Const';
@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})


@Injectable()
export class DownloadsComponent implements OnInit, AfterViewInit {
  dataAdapter: any;
  columns: any[];
  guid: string = '';
  @ViewChild("downloadGrid") downloadGrid: jqxGridComponent;
 
  baseURL: any;
  @ViewChild('email') private email;
 // @ViewChild('emailStore', { static: false }) private emailStore;
  @ViewChild('sendNotificationWindow') sendNotificationWindow: jqxWindowComponent;

  emailAddress: string;
  returnUrl: string;

  ngOnInit() {

   
  }

  //TODO: Set timer to update for
  

  constructor(private http: HttpClient, private localStorageService: LocalStorageService, public authService: AuthService, private router: Router, @Inject('BASE_URL') url: string, private alertService: AlertService, private route: ActivatedRoute, private downloadService: DownloadService, private msalService: MsalService) {
    this.alertService.startLoadingMessage();
    this.route.queryParams.subscribe(params => {
      if (params['guid'] != '')
        this.guid = params['guid'];
    });

    this.baseURL = url;

    if (this.authService.currentUser != undefined && this.authService.currentUser.email != "") {
      this.emailAddress = this.authService.currentUser.email;
    }


    setInterval(() => {
      this.refreshData();
    }, 10000);

    
    this.alertService.stopLoadingMessage();
  }

  ngAfterViewInit() {
    this.refreshData();

  }



  logout() {
    //this.returnUrl = this.route.snapshot.queryParams['return'] || '/';
    //this.authService.logOff();
    //this.router.navigate(["/view-map"]);

    if (this.msalService.instance.getActiveAccount() != null) {
      this.getLogOffEndpoint().subscribe();
      this.msalService.logoutRedirect({
        postLogoutRedirectUri: window.location.href
      }).subscribe();
      this.localStorageService.removeData(Const.CurrentUser);
    }

  }
  getLogOffEndpoint() {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
    return this.http.post('/account/LogOff', null, options);
  }

  login() {
    this.returnUrl = window.location.href;
    if (this.msalService.instance.getActiveAccount() == null) {
      this.alertService.startLoadingMessage('', 'Attempting login...');
      this.authService.loginUser().subscribe((response: AuthenticationResult) => {
        this.msalService.instance.setActiveAccount(response.account);
        this.authService.getLoginEndpoint<LoginResponse>(response.account.localAccountId, response.account.name, this.msalService.instance.getActiveAccount().idTokenClaims.preferred_username).pipe(
          map(response => this.authService.processLoginResponse(response)))
          .subscribe(
            user => {
              this.alertService.stopLoadingMessage();
              this.alertService.showMessage('Login', `Welcome ${user.userName}`, MessageSeverity.information);
              this.router.navigate([this.returnUrl]);
            },
            error => {
              this.alertService.showMessage('Unable to login', Core.getHttpResponseMessage('', error), MessageSeverity.error);
              this.alertService.stopLoadingMessage();
            });

      });
    }
  }

  refreshData() {
    if (this.downloadService == undefined) return;
    this.downloadService.getdownloads(this.guid).subscribe(
      download => {
        if (download.localdata.length == 0) {
          var container = document.getElementById('container');
          container.setAttribute("style", "visibility:hidden;width: 0px; height:0px;");
          this.alertService.showMessage('Information', 'This link is not active anymore', MessageSeverity.information);
          return;
        }
       this.dataAdapter = new jqx.dataAdapter(download);
        this.columns =
          [
            { text: 'partguid', datafield: 'partGUID', hidden: true },
            { text: 'Theme', datafield: 'theme', width: 250 },
            { text: 'Dataset', datafield: 'dataset', width: 250},
            { text: 'Public Events', datafield: 'publicEvents', width: 130 },
            { text: 'Restricted Events', datafield: 'restrictedEvents', width: 130 },
            { text: 'Status', datafield: 'downloadStatus', width: 100 },
            { text: 'Time period', datafield: 'date', width: 250 },
            { text: 'Data Criteria', datafield: 'dataCriteria'},
          { text: 'Download', datafield: 'downloadStatusID', width: 80, cellsrenderer: this.downloadRender }

          ];

        var container = document.getElementById('container');
        container.setAttribute("style", "visibility:visible;width: 100%; height:800px;");
        var downloadAllbtn = document.getElementById('downloadAllbtn');
        downloadAllbtn.setAttribute("style", "visibility:visible;");
        var sendNotificationbtn = document.getElementById('sendNotificationbtn');
        var isFinished = true;
        var includeRestricted = false;

        for (var i = 0; i < download.localdata.length; i++) {
          if (download.localdata[i].email != "" && download.localdata[i].email != null)
            sendNotificationbtn.setAttribute("style", "visibility:hidden;");
          if (download.localdata[i].downloadStatusID == 1) {
            downloadAllbtn.setAttribute("style", "visibility:hidden;");
            isFinished = false;
          }
          if (download.localdata[i].accessLevel == 'Restricted')
            includeRestricted = true;
        }

        if (isFinished)
          sendNotificationbtn.setAttribute("style", "visibility:hidden;");


        if (!includeRestricted) {
          var container = document.getElementById('RestrictedData');
          container.setAttribute("style", "visibility:hidden;");
          var container = document.getElementById('RestrictedDataMessage');
          container.setAttribute("style", "visibility:hidden;");
          this.columns =
            [
              { text: 'partguid', datafield: 'partGUID', hidden: true },
              { text: 'Theme', datafield: 'theme', width: 250 },
              { text: 'Dataset', datafield: 'dataset', width: 250 },
              { text: 'Status', datafield: 'downloadStatus', width: 100 },
              { text: 'Time period', datafield: 'date', width: 250 },
              { text: 'Data Criteria', datafield: 'dataCriteria' },
              { text: 'Download', datafield: 'downloadStatusID', width: 80, cellsrenderer: this.downloadRender }

            ];
        }
        else {

          this.columns =
            [
              { text: 'partguid', datafield: 'partGUID', hidden: true },
              { text: 'Theme', datafield: 'theme', width: 250 },
              { text: 'Dataset', datafield: 'dataset', width: 250 },
              { text: 'Public Events', datafield: 'publicEvents', width: 130 },
              { text: 'Restricted Events', datafield: 'restrictedEvents', width: 130 },
              { text: 'Permission to Restricted Events', datafield: 'permission', width: 220, cellsrenderer: this.restrictedDownloadRender.bind(this) },
              { text: 'Status', datafield: 'downloadStatus', width: 100 },
              { text: 'Time period', datafield: 'date', width: 250 },
              { text: 'Data Criteria', datafield: 'dataCriteria' },
              { text: 'Download', datafield: 'downloadStatusID', width: 80, cellsrenderer: this.downloadRender }

            ];
          var container = document.getElementById('RestrictedData');
          container.setAttribute("style", "visibility:visible;");
          if (this.authService.currentUser != undefined && this.authService.currentUser.email != "") {
            var container = document.getElementById('RestrictedDataMessage');
            container.setAttribute("style", "visibility:hidden;");
          }
          else {
            var container = document.getElementById('RestrictedDataMessage');
            container.setAttribute("style", "float: left; font-size: 18px; font-weight: bold;visibility:visible;");

          }
        }

      },
      error => {
        this.alertService.showMessage('Unable to load download parts', Core.getHttpResponseMessage('', error), MessageSeverity.error);
      }
    )
  }

  Cellclick(event: any): void {
    // Do Something
    var args = event.args;
    var rowBoundIndex = args.rowindex;
    var columnindex = args.columnindex;
    var rowdata = this.downloadGrid.getrowdata(rowBoundIndex);
    if (args.datafield == 'downloadStatusID' && rowdata.downloadStatusID == 2) {
      window.location.href = this.baseURL + 'Download/DownloadPart/' + rowdata.partGUID
      //TODO: test downlod and downloadpart
    }
  }


  ngAfterViewChecked(): void {
    
  }


  downloadRender(row, datafield, value) {
    if (value == 2)
      return '<button style="width: 80px; height: 32px;cursor:pointer;" title="Download"> <span class="glyphicon glyphicon-download-alt"> </span> </button>';
      else
      return '<button style="width: 80px; height: 32px;"> <img style="margin-left: 5px; " height="20" title="Under process" alt="Under process" width="20" src="../image/loading.gif"/></button>';
  }

  restrictedDownloadRender(row, datafield, value) {
    var rowdata = this.downloadGrid.getrowdata(row);
    if (rowdata.downloadStatusID == 1)
      return '<button style="width: 250px; height: 32px;"> <img style="margin-left: 5px; " height="20" title="Under process" alt="Under process" width="20" src="../image/loading.gif"/></button>';

    if (value == 1)
      return '<div style="width: 250px; height: 32px; display: flex; align-items: center; justify-content: center; background-color:#99FF99"; color: black; title="' + rowdata.permissionMessage + '">Full</div>';
    else
    if (value == 2)
      return '<div style="width: 250px; height: 32px; display: flex; align-items: center; justify-content: center; background-color:#f2be7a"; color: black; title="' + rowdata.permissionMessage + '">Partially</div>';
    else
      return '<div style="width: 250px; height: 32px; display: flex; align-items: center; justify-content: center; background-color:#f27a7a"; color: black; title="' + rowdata.permissionMessage + '">NotPermitted</div>';
  }

  downloadAll() {
    window.location.href = this.baseURL + 'Download/' + this.guid;
  }

 

  showSendNotificationWindow() {
    this.sendNotificationWindow.open();
  }

  closeSendNotificationWindow() {
    this.sendNotificationWindow.close();
  }

  sendNotification() {
    if (this.emailAddress == "") {
      this.alertService.showMessage('Email Address is required', '', MessageSeverity.error);
      return;
    }
    //else
    //  if (this.emailAddress != "" && !this.emailStore.value) {
    //    this.alertService.showMessage('Please accept to store the email at ICES Dataportal', '', MessageSeverity.error);
    //    return;
    //  }
    this.downloadService.sendNotification(this.guid, this.emailAddress).subscribe(
      download => {
        this.sendNotificationWindow.close();
        this.refreshData();
        this.alertService.showRemainMessage('Success', 'You have successfully submitted a request to get notification. When the data have been extracted, you will get an e-mail with a link to download data.', MessageSeverity.information);

      },
      error => {
        this.alertService.showMessage('Unable to register email for download', Core.getHttpResponseMessage('', error), MessageSeverity.error);
      }
    );

      


  }


  getWidth(): any {
    return '100%';
  }
}




